import React from 'react';
const stats = [{
  value: '+500',
  label: 'profesores de natación',
  color: 'text-[#FF6B00]'
}, {
  value: '6+6',
  label: 'Tomos + Bonos',
  color: 'text-[#FF6B00]'
}, {
  value: '4.9/5',
  label: 'calificación ⭐',
  color: 'text-[#FF6B00]'
}, {
  value: '🌎',
  label: 'Mundial',
  color: 'text-[#00C2FF]'
}];
const testimonials = [{
  initials: 'RG',
  quote: 'Organicé todo el año en una tarde. Nunca más improviso una clase de natación.',
  name: 'Roberto G.',
  country: 'México 🇲🇽'
}, {
  initials: 'CM',
  quote: 'Mis alumnos principiantes completaron su primer largo en 6 semanas. Nunca había pasado.',
  name: 'Camila M.',
  country: 'Colombia 🇨🇴'
}, {
  initials: 'JA',
  quote: 'Antes tardaba 2 horas en armar la sesión del lunes. Ahora abro el tomo y listo.',
  name: 'Javier A.',
  country: 'Chile 🇨🇱'
}];
export function SocialProofBar() {
  return <section className="w-full bg-[#0A0A0F] py-10 px-4" data-id="element-176">
      <div className="max-w-3xl mx-auto" data-id="element-177">
        {/* Stats - compact inline */}
        <div className="flex items-center justify-around bg-[#16161F] border border-[#FF6B0033] rounded-xl px-4 py-4 mb-6" data-id="element-178">
          {stats.map((s, i) => <div key={i} className="text-center" data-id="element-179">
              <div className={`text-2xl sm:text-3xl font-black ${s.color}`} data-id="element-180">
                {s.value}
              </div>
              <div className="text-[#B0B0C0] text-[10px] sm:text-xs font-semibold mt-0.5" data-id="element-181">
                {s.label}
              </div>
            </div>)}
        </div>

        {/* Micro testimonials - compact list */}
        <div className="bg-[#16161F] border border-[#FF6B0033] rounded-xl divide-y divide-[#FF6B0033]" data-id="element-182">
          {testimonials.map(t => <div key={t.initials} className="flex items-center gap-3 px-4 py-3" data-id="element-183">
              <div className="w-9 h-9 rounded-full bg-[#FF6B00] flex items-center justify-center text-white font-black text-xs flex-shrink-0" data-id="element-184">
                {t.initials}
              </div>
              <p className="text-[#B0B0C0] text-xs sm:text-sm flex-1 italic" data-id="element-185">
                "{t.quote}"
              </p>
              <span className="text-[10px] sm:text-xs text-[#FF6B00] font-bold flex-shrink-0 hidden sm:block" data-id="element-186">
                {t.name} · {t.country}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}